<ul id="link-flex-dropdown" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="link-flex">
  <li *ngFor="let flex of flexs" role="menuitem">
    <span (click)="flex.isFlexDisabled ?  null : onSelectFlex(flex)" 
          class="dropdown-item" 
          [class.disabled]="flex.isFlexDisabled" 
          [style.pointer-events]="flex.isFlexDisabled ? 'none' : 'auto'">
      {{ flex.name }}
    </span>
  </li>
</ul>
